<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Pagos del personal</h2>
    <MainPersonalPayment />
  </div>
</template>

<script>
import MainPersonalPayment from "@/components/Users/PersonalPayment/MainPersonalPayment.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "PersonalPayment",
  components: {
    MainPersonalPayment,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
